import { Plugin as ProseMirrorPlugin } from 'prosemirror-state';
export const styleMarkerAttributeName = 'data-exeditor-injected-by';
export function createProseMirrorPluginByStyles(name, styles) {
    return new ProseMirrorPlugin({
        view() {
            const styleNode = document.createElement('style');
            styleNode.textContent = styles;
            styleNode.setAttribute(styleMarkerAttributeName, name);
            // 越靠前的插件优先级越高，所以 prepend
            document.head.prepend(styleNode);
            return {
                destroy: () => styleNode.remove(),
            };
        },
    });
}
//# sourceMappingURL=styles.js.map